import React, { useState, useEffect, useRef } from "react";
import { Row, Col, Card } from "react-bootstrap";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./index.css";
import { QuestionarioPublicoService } from "../../services/QuestionarioPublicoService";
import { trackPromise, usePromiseTracker } from "react-promise-tracker";
import { errorToast } from "../DommusToast";
import DommusLoading from "../DommusLoading/DommusLoading";

export function RespostaDoQuestionario({ idQuestionarioPublico, fecharRespostas }) {
  const areaRespostaQuestionarioPublico = 'resposta-questionario-publico'
  const [isClosing, setIsClosing] = useState(false);
  const [questionarioPublico, setQuestionarioPublico] = useState(null)
  const containerRef = useRef(null);
  const { promiseInProgress } = usePromiseTracker({ area: areaRespostaQuestionarioPublico })

  useEffect(() => {
    buscarDadosQuestionarioPublico()
  }, [idQuestionarioPublico])

  const handleClose = () => {
    setIsClosing(true);
    setTimeout(() => {
      fecharRespostas();
    }, 280);
  };

  // Fechar ao clicar fora
  useEffect(() => {
    function handleClickOutside(event) {
      if (containerRef.current && !containerRef.current.contains(event.target)) {
        handleClose();
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  function buscarDadosQuestionarioPublico() {
    trackPromise(QuestionarioPublicoService.buscarPoridQuestionarioPublico(idQuestionarioPublico), areaRespostaQuestionarioPublico)
      .then(response => setQuestionarioPublico(response.data))
      .catch(error => {
        console.error("Erro ao buscar questionário público:", error);
        console.log(error.response)
        errorToast.fire({ text: 'Houve um erro ao buscar os dados do questionário público.' })
        handleClose()
      })
  }

  return (
    <div
      ref={containerRef}
      className={`resposta-slide-container mt-3 ${isClosing ? "slide-down" : "slide-up"}`}
    >
      <Card style={{ backgroundColor: promiseInProgress && '#eee' || '#fff' }} className="shadow-sm w-100">
        <Card.Body>
          {/* Título */}
          <Row className="d-flex justify-content-between align-items-center mb-3">
            <Col xs="auto">
              <h6 className="mb-0">{questionarioPublico?.questionario.descricao}</h6>
            </Col>
            <Col xs="auto">
              <FontAwesomeIcon
                icon={faTimes}
                size="lg"
                role="button"
                className="text-dark"
                onClick={handleClose}
              />
            </Col>
          </Row>
            {promiseInProgress && (<div className="pb-3">
                <DommusLoading loadWrapperPosition="relative" fundo="transparent"/>
            </div>) || <></>}

          {questionarioPublico?.questionario.perguntas.map((p, index) => {
            const pergunta = p.pergunta;
            const respostaCliente = questionarioPublico?.respostas?.find(resposta => Number(resposta.id_pergunta) === Number(p.id_pergunta))

            return (
              <div key={index} className="mb-3">
                {/* Enunciado */}
                <div className="text-muted small mb-1">
                  {pergunta.enunciado}
                </div>

                {/* Resposta */}
                <Card className="p-2">
                  <span className="fs-6">
                    {respostaCliente?.resposta?.value || "Sem resposta registrada"}
                  </span>
                </Card>
              </div>
            );
          })}

          {/* Comentário */}
          {questionarioPublico?.questionario.habilita_comentario === 1 && (
            <>
              <div className="text-muted small mt-3 mb-1">Comentário</div>

              <Card className="p-2">
                <span className="fs-6">
                  {questionarioPublico?.comentario || "Sem comentário registrado"}
                </span>
              </Card>
            </>
          )}

        </Card.Body>
      </Card>
    </div>
  );
}